export const SET_USER = 'SET_USER';

export const LOADING_START = 'LOADING_START';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';
export const LOADING_ERROR = 'LOADING_ERROR';

export const CLEAR_STATE = 'CLEAR_STATE';
